export default "__VITE_ASSET__BqQ7l4pX__"